// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3GXg_","consentsList":"PatientConsents_consentsList__2FZky","consentsListEmpty":"PatientConsents_consentsListEmpty__3X2rU"};